/* eslint-disable no-nested-ternary */
/* eslint-disable no-restricted-globals */
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import EditHistoryFrom from './EditHistoryFrom'
import {
  Table,
  TableContainer,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  Box,
  Button,
} from '@chakra-ui/react'
import _ from 'lodash'
import dayjs from 'dayjs'

export default function RenderDataHistoryForm({
  form,
  formInput,
  formId,
  modalOpen = () => {},
  handleDelete = () => {},
}) {
  const checkHeadTable = (data) => {
    if (data?.formType === 'CALCULATE') {
      return (
        <Td w="10%" borderColor={'black'} borderBottom={'1px'} borderX="1px">
          <div className="text-center"></div>
        </Td>
      )
    } else if (data?.attribute?.length === 0 || data?.formType === 'SELECTOR') {
      return (
        <Td w="10%" borderColor={'black'} borderBottom={'1px'} borderX="1px">
          <div className="text-center"></div>
        </Td>
      )
    } else {
      return _.map(data?.attribute, (eachCol) => (
        <Th w="10%" borderBlock={'black'} border="1px">
          <div className="text-center">{eachCol?.subTopic}</div>
        </Th>
      ))
    }
  }

  const checkType = (data) => {
    if (typeof data === 'number') {
      return Number(data).toFixed(2)
    } else if (typeof data === 'boolean') {
      return <div>{data === true ? <i className="fas fa-check"></i> : ''}</div>
    } else if (data === dayjs(data).format('YYYY-MM-DD')) {
      return dayjs(data).format('D/MM/BBBB')
    } else if (
      isNaN(Intl.NumberFormat('en-US').format(Number(data).toFixed(2))) &&
      isNaN(Number.parseFloat(data)) === false
    ) {
      return isNaN(
        Intl.NumberFormat('en-US').format(Number(data).toFixed(2))
      ) === true
        ? data
        : Intl.NumberFormat('en-US').format(Number(data).toFixed(2))
    } else {
      return data
    }
  }

  const renderTableBody = (colName, rows, index) => {
    if (colName?.formType === 'CALCULATE') {
      const dd = Number(rows[colName?.name]).toFixed(2)
      return (
        <Td w="10%" borderBlock={'black'} border="1px">
          <div className="text-center">
            {Intl.NumberFormat('en-US').format(dd) || '-'}
          </div>
        </Td>
      )
    } else if (
      colName?.attribute?.length === 0 ||
      colName?.formType === 'SELECTOR'
    ) {
      return (
        <Td w="10%" borderBlock={'black'} border="1px">
          <div className="text-center">
            {checkType(rows[colName?.name]) || '-'}
          </div>
        </Td>
      )
    } else {
      return _.map(colName?.attribute, (eachCol) => (
        <Td w="10%" borderBlock={'black'} border="1px">
          <div className="text-center ">
            {checkType(rows?.[colName?.name]?.[eachCol?.subTopic]) || '-'}
          </div>
        </Td>
      ))
    }
  }

  const renderCard = () => (
    <div>
      <TableContainer>
        <Table colorScheme="gray" size="sm" border="2px">
          <Thead bg={'gray.200'} border="1px">
            <Tr borderColor="black" borderTop="1px">
              <Td
                rowSpan={2}
                borderBlock={'black'}
                borderBottom={'1px'}
                borderX="1px"
                sx={{ width: '10' }}
              >
                {' '}
                <div className="text-center font-bold">
                  วันที่ต้องการกรอก(date)
                </div>
              </Td>
              {_.map(form?.components, (row) => (
                <Td
                  borderBlock={'black'}
                  borderBottom={'1px'}
                  borderX="1px"
                  sx={{ width: '10' }}
                  w="100%"
                  colSpan={_.size(
                    row?.formType === 'SELECTOR'
                      ? 1
                      : row?.formType === 'CALCULATE'
                      ? 1
                      : row?.attribute
                  )}
                >
                  <div className="text-center font-bold">{row?.topic}</div>
                </Td>
              ))}
              <Td
                rowSpan={2}
                borderBlock={'black'}
                borderBottom={'1px'}
                borderX="1px"
                sx={{ width: '10' }}
              >
                {' '}
                <div className="text-center font-bold">
                  วันที่กรอก(createdAt)
                </div>
              </Td>
              <Td
                rowSpan={2}
                borderBlock={'black'}
                borderBottom={'1px'}
                borderX="1px"
                sx={{ width: '10' }}
              >
                {' '}
                <div className="text-center font-bold">ผู้กรอก</div>
              </Td>
            </Tr>
            <Tr> {_.map(form?.components, (row) => checkHeadTable(row))}</Tr>
          </Thead>
          <Tbody>
            {_.map(formInput?.arr, (row, index) => (
              <Tr key={index} borderColor="black" border="1px">
                <Td borderBlock={'black'}>
                  {dayjs(row?.date).locale('th').format('D MMM HH:mm')}
                </Td>
                {_.map(form?.components, (col) =>
                  renderTableBody(col, row, index)
                )}
                <Td borderBlock={'black'} borderX="1px">
                  {dayjs(row?.createdAt).locale('th').format('D MMM HH:mm')}
                </Td>
                <Td borderBlock={'black'} borderX="1px">
                  {row?.recorder?.name}
                </Td>
                <Td style={{ border: 'none' }}>
                  <div className="flex gap-1">
                    <Button
                      colorScheme="yellow"
                      size="xs"
                      onClick={() => modalOpen(row)}
                    >
                      <Link
                        to={`/humaninput/history/formList/historyDetail/edit/${form?._id}/${formId}/${row?._id}`}
                      >
                        แก้ไข
                      </Link>
                    </Button>
                    <Button
                      colorScheme="red"
                      size="xs"
                      onClick={() => {
                        handleDelete(row?._id)
                      }}
                    >
                      ลบ
                    </Button>
                  </div>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </div>
  )

  return <div> {renderCard()}</div>
}
